import { render, staticRenderFns } from "./InvitationCardSkeleton.vue?vue&type=template&id=212ad49d&scoped=true"
var script = {}
import style0 from "./InvitationCardSkeleton.vue?vue&type=style&index=0&id=212ad49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ad49d",
  null
  
)

export default component.exports